/* eslint-disable max-lines */
import { RuleGroup, UUID } from '@litlingo/client';
import { deleteCategories } from 'actions';
import LoadingIndicator from 'components/LoadingIndicator';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getDeleteTagGroupLoading } from 'selectors/tagGroup';
import { useSelector } from 'store';

type ComponentProps = {
  selectedCategories: UUID[];
  setSelectedCategories: React.Dispatch<React.SetStateAction<string[]>>;
  toggleJsonModal: () => void;
  rule: RuleGroup;
};

const CategoryListActionRow: React.FC<ComponentProps> = ({
  selectedCategories,
  setSelectedCategories,
  rule,
  toggleJsonModal,
}) => {
  const dispatch = useDispatch();

  const deleteLoading = useSelector(getDeleteTagGroupLoading);

  const handleDelete = (): void => {
    dispatch(deleteCategories({ categories: selectedCategories, ruleId: rule.uuid }));
    setSelectedCategories([]);
  };

  return (
    <>
      <tr className="bg-litlingo-gray-2">
        <th
          colSpan={10}
          className="table-wrapper__new-td table-wrapper__bulk-area bg-litlingo-gray-2"
        >
          <div className="table-wrapper__new-cell-content flex flex-row justify-between items-start gap-3 py-2 m-0 h-auto overflow-visible">
            <div className="w-full pl-6 pr-4 flex flex-row justify-between items-start gap-2">
              <button
                type="button"
                disabled={selectedCategories.length > 1}
                onClick={(): void => toggleJsonModal()}
                className="button button--secondary font-bold h-8 flex justify-center"
              >
                JSON Editor
              </button>
              <button
                type="button"
                onClick={(): void => handleDelete()}
                className="button button--secondary font-bold h-8 w-24 flex justify-center"
              >
                <span className="text-litlingo-red-bg font-bold">
                  {deleteLoading ? <LoadingIndicator size="5" /> : 'Delete'}
                </span>
              </button>
            </div>
          </div>
        </th>
      </tr>
    </>
  );
};

export default CategoryListActionRow;
